export const IconGift = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath="url(#IconGift_svg__a)">
        <path d="m20.859 11.454.068-.03A1.97 1.97 0 0 0 22 9.678V8.537a1.96 1.96 0 0 0-1.961-1.961h-1.873l.078-.176c.185-.41.283-.839.283-1.298A3.11 3.11 0 0 0 15.424 2c-1.014 0-1.804.38-2.4 1.17-.38.498-.673 1.171-.917 1.757l-.117.273-.117-.273c-.244-.586-.536-1.249-.917-1.756C10.361 2.39 9.58 2 8.556 2a3.106 3.106 0 0 0-2.82 4.4l.079.176H3.94a1.96 1.96 0 0 0-1.96 1.96v1.142c0 .732.419 1.415 1.073 1.746l.068.03v8.585C3.122 21.122 4 22 5.082 22h13.796a1.96 1.96 0 0 0 1.961-1.961v-8.585zM9.473 20.37h-4.37a.33.33 0 0 1-.332-.332v-8.41h4.692v8.732zm0-10.371H3.961a.33.33 0 0 1-.332-.332V8.527c0-.186.147-.332.332-.332h5.512V10m1.142-3.424h-2.04c-.81 0-1.473-.664-1.473-1.474S7.766 3.63 8.576 3.63c.965 0 1.258.488 2.156 2.771l.068.166h-.176zm2.283 13.795h-1.796V8.205h1.796zm.38-13.971c.898-2.283 1.18-2.77 2.156-2.77.81 0 1.473.663 1.473 1.472 0 .81-.663 1.474-1.473 1.474H13.21l.068-.166zm5.951 13.639a.33.33 0 0 1-.331.332h-4.371v-8.732h4.693v8.41zm1.142-10.361a.33.33 0 0 1-.332.332h-5.512V8.215h5.512c.185 0 .332.146.332.331v1.142z" />
      </g>
      <defs>
        <clipPath id="IconGift_svg__a">
          <path d="M2 2h20v20H2z" />
        </clipPath>
      </defs>
    </svg>
  );
};
